import { CeidgExtendedReportData } from './ceidg.model';
import { GridFSFile } from './file.model';
import {
  KrsExtendedReportCompanyAuthoritiesData,
  KrsExtendedReportPropertyRightsData,
} from './krs.model';
import { Deceased } from './order.model';
import {
  CrbrExtendedReportData,
  KrzExtendedReportData,
  MsigExtendedReportData,
  SudopExtendedReportData,
  VatWlExtendedReportData,
} from './report-extended-data.model';

export interface BaseDeceasedReport {
  status: ReportStatus;
  type: ReportType;
  reportNumber: string;
  order: OrderSmall,
  reportFile?: GridFSFile | null;
  updatedAt: Date;
  createdAt: Date;
  databaseStatusOn: Date | null;
  deceased: Deceased;
  lookup: ReportLookup | null; //| ExtendedReportLookup
  // result: PrimaryReportResult | ExtendedReportResult,
}
export type DeceasedReport =
  | (BaseDeceasedReport & {
      type: ReportType.PRIMARY;
      result: PrimaryReportResult;
    })
  | (BaseDeceasedReport & {
      type: ReportType.EXTENDED;
      result: ExtendedReportResult;
    });
export interface OrderSmall {
  orderNumber: string;
  createdAt: Date;
  updatedAt: Date;
  client: {
    name: string;
    lastName: string;
    email: string;
  };
}
export enum ReportType {
  PRIMARY = 'PRIMARY',
  EXTENDED = 'EXTENDED',
}

export enum ReportStatus {
  NEW = 'NEW',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  FAILED = 'FAILED',
  PROCESSED = 'PROCESSED',
  SKIPPED = 'SKIPPED',
}
export interface ReportLookup {
  krs: ReportLookupInfo;
  ceidg: ReportLookupInfo;
  crbr: ReportLookupInfo;
  krz: ReportLookupInfo;
  msig: ReportLookupInfo;
  vatWl: ReportLookupInfo;
  sudop: ReportLookupInfo;
}

export interface ReportLookupInfo {
  status: ReportStatus;
  timestamp: Date;
}

export interface PrimaryReportResult {
  krs: {
    propertyRights: ReportResultStatus;
    companyAuthorities: ReportResultStatus;
  };
  ceidg: ReportResultStatus;
  crbr: ReportResultStatus;
  krz: ReportResultStatus;
  msig: ReportResultStatus;
  vatWl: ReportResultStatus;
  sudop: ReportResultStatus;
}

export enum ReportResultStatus {
  NOT_EXISTS = 'NOT_EXISTS',
  EXISTS = 'EXISTS',
  SKIPPED = 'SKIPPED',
  PENDING = 'PENDING',
}

export interface ExtendedReportResult {
  krs: {
    propertyRights: ExtendedResult<
      KrsExtendedReportPropertyRightsData[] | null
    >;
    companyAuthorities: ExtendedResult<
      KrsExtendedReportCompanyAuthoritiesData[] | null
    >;
  };
  ceidg: ExtendedResult<CeidgExtendedReportData[] | null>;
  crbr: ExtendedResult<CrbrExtendedReportData[] | null>;
  krz: ExtendedResult<KrzExtendedReportData | null>;
  msig: ExtendedResult<MsigExtendedReportData[] | null>;
  vatWl: ExtendedResult<VatWlExtendedReportData | null>;
  sudop: ExtendedResult<SudopExtendedReportData | null>;
}

export interface ExtendedResult<TData> {
  status: ReportResultStatus;
  data: TData;
  files: GridFSFile[] | null;
}

export interface DeceasedReportStatus {
  status: ReportStatus;
  deceased: Deceased;
  lookup: ReportLookup;
}

export {
  CrbrExtendedReportData,
  KrzExtendedReportData,
  MsigExtendedReportData,
  SudopExtendedReportData,
  VatWlExtendedReportData,
} from './report-extended-data.model';
